import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Dropdown, Image, Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import logo from "../assets/images/logo.svg";
import logo_dark from "../assets/images/logo_dark.svg";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from "react-currency-format";
// import api
import { logout, UpdateLanguage } from "../api/users";
import ThemeToggle from "./ThemeToggle";
import { useTheme } from "./ThemeContext";

//import lib
import { toFixedDown, truncateDecimals } from "../lib/roundOf";
import isEmpty from "../lib/isEmpty";
import { toastAlert } from "../lib/toastAlert";
import { unrealizedPnL } from "../lib/bybit";

//import modal
import ProfileUpdateModal from "./AccountSettings/ProfileModal";
import {
  getArbiProfit,
  getAssetData,
  setAvailableBal,
} from "../api/walletAction";
import { getStackingEstimate } from "../api/staking";
import { currencyChange } from "../lib/pairHelper";
import { getLang, setLang } from "../lib/localStorage";
import { getAllOpenPosition } from "../api/tradeAction";
import SocketContext from "../context/SocketContext";

const NavbarInner = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // redux-state
  const { notifiyCount, unread } = useSelector((state) => state.notice || { unread: [] });
  const currency = useSelector((state) => state.currency);
  const walletData = useSelector((state) => state.wallet);
  const priceConversion = useSelector((state) => state.priceConversion);
  const { isStake, defaultcurrency, isHedge, isTrade, isLiveEvents, langCode } =
    useSelector((state) => state.account);
  const availableBal = useSelector((state) => state.availableBal);
  const siteDoc = useSelector((state) => state.siteSetting);
  const pairListData = useSelector((state) => state.pairList);
  const marketPrice = useSelector((state) => state.marketPrice);

  //state
  const [available, setTotalAvailable] = useState(0);
  const [tradedata, setTradeData] = useState();
  const [ProfileModal, setProfileModal] = useState(false);
  const [arbitragePnl, setarbitragePnl] = useState(0);
  const [data, setData] = useState();
  const [totalPair, setTotalPair] = useState([]);
  const [totalPNL, setTotalPNL] = useState(0);
  const [equity, setEquity] = useState(0);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleCloseOffcanvas = () => setShowOffcanvas(false);
  const handleShowOffcanvas = () => setShowOffcanvas(true);

  const { theme } = useTheme();
  const socketContext = useContext(SocketContext);

  //function
  function loadScript() {
    // Navbar Sticky
    var t = $(".navbar-sticky");
    $(window).on("scroll load", function (e) {
      var e = $(window).scrollTop();
      120 <= e
        ? t.addClass("navbar-sticky--moved-up")
        : t.removeClass("navbar-sticky--moved-up");
      250 <= e
        ? t.addClass("navbar-sticky--transitioned")
        : t.removeClass("navbar-sticky--transitioned");
      500 <= e
        ? t.addClass("navbar-sticky--on")
        : t.removeClass("navbar-sticky--on");
    });

    $(document).ready(function () {
      $(".nav_after_login li a").click(function () {
        $("body").css({ overflow: "unset" });
      });
    });
  }

  const handleAsset = async () => {
    try {
      let totalAmount = 0;
      let tempArr = [...walletData];

      currency?.length >= 0 &&
        currency.map((item, index) => {
          let PriceCnv =
            priceConversion &&
            priceConversion.length > 0 &&
            priceConversion.find(
              (el) =>
                el.baseSymbol == item.currencySymbol &&
                el.convertSymbol == "USD",
            );
          let pairIndex =
            tempArr &&
            tempArr.findIndex((el) => {
              return el._id == item._id;
            });
          if (pairIndex >= 0 && !isEmpty(pairIndex)) {
            tempArr[pairIndex] = {
              ...tempArr[pairIndex],
              ...{
                USDValue: !isEmpty(PriceCnv?.convertPrice)
                  ? parseFloat(
                      tempArr[pairIndex].stakeBal -
                        tempArr[pairIndex].lockedBal,
                    ) * parseFloat(PriceCnv?.convertPrice)
                  : parseFloat(
                      tempArr[pairIndex].stakeBal -
                        tempArr[pairIndex].lockedBal,
                    ),
              },
            };
            totalAmount += tempArr[pairIndex].USDValue;
          }
        });
      if (defaultcurrency == "USD") {
        setTotalAvailable(totalAmount);
        setarbitragePnl(availableBal?.profit);
      } else {
        let PriceChange =
          priceConversion &&
          priceConversion.length > 0 &&
          priceConversion.find(
            (el) =>
              el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency,
          );
        if (PriceChange?.convertPrice) {
          let totalbalance = !isEmpty(PriceChange?.convertPrice)
            ? parseFloat(totalAmount * PriceChange?.convertPrice)
            : 0;
          let totalPNlL = !isEmpty(PriceChange?.convertPrice)
            ? parseFloat(PriceChange?.convertPrice * availableBal?.profit)
            : 0;
          setTotalAvailable(totalbalance);
          setarbitragePnl(totalPNlL);
        }
      }
    } catch (err) {
      console.log("err:------", err);
    }
  };

  const getStackinginfo = async (spotPairId, type) => {
    try {
      const { status, result } = await getStackingEstimate(spotPairId);
      if (status == "success") {
        // console.log(result, "---------- reulst")
        if (!isEmpty(result)) {
          if (defaultcurrency == "USD") {
            setTradeData(result?.actStackToTalAmou);
          } else {
            let PriceChange =
              priceConversion &&
              priceConversion.length > 0 &&
              priceConversion.find(
                (el) =>
                  el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency,
              );
            if (PriceChange?.convertPrice) {
              let totalbalance = !isEmpty(PriceChange?.convertPrice)
                ? parseFloat(
                    result?.actStackToTalAmou * PriceChange?.convertPrice,
                  )
                : 0;
              setTradeData(totalbalance);
            }
          }
        }
      } else {
        setTradeData(0);
      }
    } catch (err) {
      console.log(err, "errro");
    }
  };

  const handleCloseModal = () => {
    setProfileModal(false);
  };

  useEffect(() => {
    if (
      !isEmpty(walletData) &&
      !isEmpty(currency) &&
      !isEmpty(priceConversion)
    ) {
      handleAsset();
      getStackinginfo();
    }
  }, [walletData, currency, priceConversion]);

  useEffect(() => {
    loadScript();
    getArbiProfit(dispatch);
    // getAssetData(dispatch)
  }, []);

  const handleTrade = () => {
    if (!isTrade) {
      toastAlert("error", t("TRADE_ACCESS"), "login");
    }
  };

  const handleStake = () => {
    if (!isStake) {
      toastAlert("error", t("STAKE_ACCESS"), "login");
    }
  };
  const handleLiveEvent = () => {
    if (!isLiveEvents) {
      toastAlert("error", t("LIVE_EVENT_ACCESS"), "login");
    }
  };

  const handlehedge = () => {
    if (!isHedge) {
      toastAlert("error", t("HEDGE_ACCESS"), "login");
    }
  };

  const langList = [
    {
      value: "en",
      image: require("../assets/images/EN.png"),
      label: "English",
    },
    { value: "ar", image: require("../assets/images/AR.png"), label: "Arabic" },
    { value: "fr", image: require("../assets/images/FR.png"), label: "French" },
    {
      value: "sp",
      image: require("../assets/images/SP.png"),
      label: "Spanish",
    },
    {
      value: "de",
      image: require("../assets/images/DE.png"),
      label: "Deutsch",
    },
  ];

  const [defaultLang, setDefaultLang] = useState({
    value: "en",
    image: require("../assets/images/EN.png"),
    label: "English",
  });

  const [language, setLanguage] = useState("en");

  const handleLanguage = (lang, option) => {
    setLang(lang);
    setLanguage(lang);
    setDefaultLang(option);
    i18n.changeLanguage(lang);
    window.location.reload();
  };

  const fetchTradeHistory = async () => {
    const { status, result } = await getAllOpenPosition({});
    if (status == "success") {
      setData(result);
    }
  };

  useEffect(() => {
    let langCode = getLang();

    if (isEmpty(langCode)) {
      setLang(language);
      i18n.changeLanguage(language);
    } else {
      setLang(langCode);
      i18n.changeLanguage(langCode);
      const selectedLang = langList.find((item) => item.value === langCode);
      if (selectedLang) setDefaultLang(selectedLang);
      setLanguage(langCode);
    }
  }, [language]);

  useEffect(() => {
    fetchTradeHistory();
  }, []);

  useEffect(() => {
    let allPairPriceUpdate = [...pairListData];
    const socket = socketContext.socket;

    socket.on("marketPrice", (result) => {
      if (result) {
        let pairIndex = allPairPriceUpdate.findIndex(
          (el) => el._id.toString() === result.pairId.toString(),
        );
        if (pairIndex >= 0) {
          allPairPriceUpdate[pairIndex] = {
            ...allPairPriceUpdate[pairIndex],
            ...{
              bidPrice: result?.data?.bidPrice,
              askPrice: result?.data?.askPrice,
              markPrice: result?.data?.markPrice,
              change: result?.data?.change,
            },
          };
          setTotalPair(allPairPriceUpdate);
        }
      }
    });

    // return () => {
    //   socket.off("marketPrice");
    // };
  }, [pairListData]);

  useEffect(() => {
    if (data && data.length > 0 && !isEmpty(totalPair)) {
      let totalPnl = 0;
      data.forEach((item) => {
        let filter =
          totalPair &&
          totalPair.find((el) => el._id.toString() === item.pairId.toString());
        let price = item.side === "sell" ? filter?.askPrice : filter?.bidPrice;
        let pnl = unrealizedPnL({
          entryPrice: item.entryPrice,
          quantity: item.quantity,
          lastPrice: price,
          buyorsell: item.side,
        });

        let totalSpread =
          parseFloat(item?.userId?.userSpread || 0) +
          parseFloat(filter?.spread || 0);
        let margin = (price * item.quantity) / 100;
        totalPnl += pnl + (totalSpread * margin) / 100;
      });
      setTotalPNL(truncateDecimals(totalPnl, 2));
    }
  }, [totalPair, data, marketPrice]);

  useEffect(() => {
    const updatedEquity = parseFloat(available) + parseFloat(totalPNL);
    setEquity(updatedEquity);
  }, [available, totalPNL]);

    const { firstName, lastName, loginHistory, profile } = useSelector((state) => state.account);
  return (
    <>
      <div className="">
        <ProfileUpdateModal isShow={ProfileModal} onHide={handleCloseModal} />

        <nav className="navbar navbar-dark navbar-expand-xl main_navbar navbar-sticky">
          <Link className="navbar-brand" to="/">
            {theme === "light" ? (
              <img
                src={logo}
                className="img-fluid brand_logo"
                alt="Light logo"
              />
            ) : (
              <img
                src={logo_dark}
                className="img-fluid brand_logo"
                alt="Dark logo"
              />
            )}
          </Link>
          <ul className="p-0 m-0 navbar_main_parent">
            <ul className="navbar-nav navbar_left w-100 navbar_bottom">
              {siteDoc?.availableAccess && (
                <li className="nav-item d-flex align-items-center me-xl-2 me-xxl-5">
                  <p className="mb-0 bal">
                    <div className="tot">{t("AVAILABLE_BALANCE")}&nbsp;:</div>
                    <div>
                      {" "}
                      {currencyChange(defaultcurrency)}{" "}
                      <CurrencyFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={truncateDecimals(available, 2)}
                      />
                    </div>
                  </p>
                </li>
              )}{" "}
              {siteDoc?.stakeBalAccess && (
                <li className="nav-item d-flex align-items-center me-xl-2 me-xxl-5">
                  <p className="mb-0 bal">
                    <div className="tot">{t("STAKED_BALANCE")}&nbsp;:</div>
                    <div>
                      {" "}
                      {currencyChange(defaultcurrency)}{" "}
                      <CurrencyFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={truncateDecimals(tradedata, 2)}
                      />
                    </div>
                  </p>
                </li>
              )}{" "}
              {siteDoc?.accountAccess && (
                <li className="nav-item d-flex align-items-center me-xl-2 me-xxl-5">
                  <p className="mb-0 bal">
                    <div className="tot">{t("ACCOUNT_BALANCE")}&nbsp;:</div>
                    <div>
                      {" "}
                      {currencyChange(defaultcurrency)}{" "}
                      <CurrencyFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={truncateDecimals(
                          parseFloat(truncateDecimals(available, 2)) +
                            parseFloat(truncateDecimals(tradedata, 2)),
                          2,
                        )}
                      />
                    </div>
                  </p>
                </li>
              )}
              {siteDoc?.plAccess && (
                <li className="nav-item d-flex align-items-center me-xl-2 me-xxl-5">
                  <p className="mb-0 bal">
                    <div className="tot">{t("TOTAL_PL")}&nbsp;:</div>
                    <div>
                      {" "}
                      {currencyChange(defaultcurrency)}{" "}
                      <CurrencyFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={truncateDecimals(arbitragePnl, 2)}
                      />
                    </div>
                  </p>
                </li>
              )}
              {siteDoc?.equityAccess && (
                <li className="nav-item d-flex align-items-center me-auto">
                  <p className="mb-0 bal">
                    <div className="tot">
                      {t("TRADING")}
                      {""} {t("EQUITY")}&nbsp;:
                    </div>
                    <div>
                      {" "}
                      {currencyChange(defaultcurrency)}{" "}
                      <CurrencyFormat
                        displayType={"text"}
                        thousandSeparator={true}
                        value={truncateDecimals(equity, 2)}
                      />
                    </div>
                  </p>
                </li>
              )}
            </ul>
            <ul className="navbar-nav navbar_left w-100">
              {siteDoc?.tradeAccess && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    aria-current="page"
                    to={isTrade ? "/trade" : "/"}
                    onClick={handleTrade}
                  >
                    {t("TRADE")}
                  </NavLink>
                </li>
              )}
              {/* <li className="nav-item">
            <NavLink
              className="nav-link"
              aria-current="page"
              to={"/protrade"}
            >
              Pro-Trade
            </NavLink>
          </li> */}
              {siteDoc?.stakeAccess && (
                <li className="nav-item">
                  <NavLink
                    to={isStake ? "/staking" : "/"}
                    className="nav-link"
                    aria-current="page"
                    onClick={handleStake}
                  >
                    {t("STAKING")}
                  </NavLink>
                </li>
              )}
              {siteDoc?.walletAccess && (
                <li className="nav-item">
                  <NavLink to="/wallet" className="nav-link">
                    {t("WALLET")}
                  </NavLink>
                </li>
              )}
              {siteDoc?.transactionAccess && (
                <li className="nav-item">
                  <NavLink to="/transaction-history" className="nav-link">
                    {t("TRANSACTION")}
                  </NavLink>
                </li>
              )}
              {siteDoc?.hedgeAccess && (
                <li className="nav-item">
                  <NavLink
                    to={isHedge ? "/hedging" : "/"}
                    onClick={handlehedge}
                    className="nav-link"
                  >
                    {t("HEDGE_FUND")}
                  </NavLink>
                </li>
              )}
              {siteDoc?.historyAccess && (
                <li className="nav-item">
                  <NavLink className="nav-link" to="/stakinghistory">
                    {t("STAKING_HISTORY")}
                  </NavLink>
                </li>
              )}
              {siteDoc?.liveEventAccess && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={isLiveEvents ? "/live-events" : "/"}
                    onClick={handleLiveEvent}
                  >
                    {t("LIVE_EVENTS")}
                  </NavLink>
                </li>
              )}
              {/* <li className="nav-item">
              <NavLink to="/referral" className="nav-link">
                Referrals
              </NavLink>
            </li> */}
            </ul>
          </ul>
          <div className="navbar_right">
            <ul className="navbar-nav mb-2 mb-xl-0 nav_after_login d-none d-xl-flex">
              <li className="nav-item d-flex align-items-center me-2">
                <Link to="/notifications" className="hidden xl:flex w-10 h-10 relative rounded-full outline outline-1 outline-offset-[-1px] outline-[#395645]/10 justify-center items-center gap-2">
                  <div className="w-5 h-5 relative overflow-hidden">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.9173 15C12.9173 16.6108 11.6115 17.9167 10.0007 17.9167C8.38982 17.9167 7.08398 16.6108 7.08398 15" stroke="#395645" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M16.0259 15.0007H3.97406C3.15996 15.0007 2.5 14.3407 2.5 13.5266C2.5 13.1357 2.6553 12.7607 2.93174 12.4842L3.43443 11.9816C3.90327 11.5127 4.16667 10.8768 4.16667 10.2138V7.91732C4.16667 4.69566 6.77834 2.08398 10 2.08398C13.2217 2.08398 15.8333 4.69565 15.8333 7.91732V10.2138C15.8333 10.8768 16.0967 11.5127 16.5656 11.9816L17.0682 12.4842C17.3447 12.7607 17.5 13.1357 17.5 13.5266C17.5 14.3407 16.84 15.0007 16.0259 15.0007Z" stroke="#395645" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </div>
                  {unread && unread.length > 0 && (
                      <div className="w-4 h-4 left-[26px] top-[-3.50px] absolute overflow-hidden">
                          <div className="w-3.5 h-3.5 left-[1px] top-[1px] absolute bg-[#395645] rounded-full" />
                          <div className="left-[5px] top-[1px] absolute justify-start text-white text-[10px] font-bold font-['Inter']">{unread.length}</div>
                      </div>
                  )}
                </Link>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    alt="arrow"
                    className="img-fluid"
                    src={
                      profile
                        ? profile
                        : require("../assets/images/copy_usericon.png")
                    }
                    width={28}
                  />
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/account-settings">
                      {t("ACCOUNT_SETTINGS")}
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/support-ticket">
                      {t("SUPPORT_TICKET")}
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item">
                      <span onClick={() => setProfileModal(true)}>
                        {t("EDIT_PROFILE")}
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={() => logout(navigate, dispatch, t)}
                    >
                      {t("LOGOUT")}
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
            <button
                        className="xl:hidden block text-[#395645] focus:outline-none me-2"
                        type="button"
                        onClick={handleShowOffcanvas}
                        aria-label="Toggle navigation"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>
            <Offcanvas
              show={showOffcanvas}
              onHide={handleCloseOffcanvas}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="ms-auto">
                  {/* Balances Card */}
                  <ul className="navbar-nav mt-4 mt-xl-0 mb-6 bg-[#395645]/5 border border-[#395645]/10 rounded-2xl p-5 flex flex-col gap-4 d-xl-none shadow-sm">
                    {siteDoc?.availableAccess && (
                      <li className="nav-item">
                        <div className="mb-0 bal flex items-center justify-between w-full">
                          <div className="tot font-medium text-[15px] opacity-80">
                            {t("AVAILABLE_BALANCE")}&nbsp;:
                          </div>
                          <div className="font-bold text-[16px] tracking-tight">
                            {currencyChange(defaultcurrency)}{" "}
                            <CurrencyFormat
                              displayType={"text"}
                              thousandSeparator={true}
                              value={truncateDecimals(available, 2)}
                            />
                          </div>
                        </div>
                      </li>
                    )}{" "}
                    {siteDoc?.stakeBalAccess && (
                      <li className="nav-item">
                        <div className="mb-0 bal flex items-center justify-between w-full">
                          <div className="tot font-medium text-[15px] opacity-80">
                            {t("STAKED_BALANCE")}&nbsp;:
                          </div>
                          <div className="font-bold text-[16px] tracking-tight">
                            {currencyChange(defaultcurrency)}{" "}
                            <CurrencyFormat
                              displayType={"text"}
                              thousandSeparator={true}
                              value={truncateDecimals(tradedata, 2)}
                            />
                          </div>
                        </div>
                      </li>
                    )}{" "}
                    {siteDoc?.accountAccess && (
                      <li className="nav-item">
                        <div className="mb-0 bal flex items-center justify-between w-full">
                          <div className="tot font-medium text-[15px] opacity-80">
                            {t("ACCOUNT_BALANCE")}&nbsp;:
                          </div>
                          <div className="font-bold text-[16px] tracking-tight">
                            {currencyChange(defaultcurrency)}{" "}
                            <CurrencyFormat
                              displayType={"text"}
                              thousandSeparator={true}
                              value={truncateDecimals(
                                parseFloat(truncateDecimals(available, 2)) +
                                  parseFloat(truncateDecimals(tradedata, 2)),
                                2,
                              )}
                            />
                          </div>
                        </div>
                      </li>
                    )}
                    {siteDoc?.plAccess && (
                      <li className="nav-item pt-4 mt-1 border-t border-[#395645]/10">
                        <div className="mb-0 bal flex items-center justify-between w-full">
                          <div className="tot font-medium text-[15px] opacity-80">{t("TOTAL_PL")}&nbsp;:</div>
                          <div className={`font-bold text-[16px] tracking-tight ${arbitragePnl < 0 ? 'text-[#ff6363]' : 'text-[#02a229]'}`}>
                            {currencyChange(defaultcurrency)}{" "}
                            <CurrencyFormat
                              displayType={"text"}
                              thousandSeparator={true}
                              value={truncateDecimals(arbitragePnl, 2)}
                            />
                          </div>
                        </div>
                      </li>
                    )}
                    {siteDoc?.equityAccess && (
                      <li className="nav-item pt-4 mt-1 border-t border-[#395645]/10">
                        <div className="mb-0 bal flex items-center justify-between w-full">
                          <div className="tot font-medium text-[15px] opacity-80">{t("EQUITY")}&nbsp;:</div>
                          <div className="font-bold text-[16px] tracking-tight">
                            {currencyChange(defaultcurrency)}{" "}
                            <CurrencyFormat
                              displayType={"text"}
                              thousandSeparator={true}
                              value={truncateDecimals(equity, 2)}
                            />
                          </div>
                        </div>
                      </li>
                    )}
                  </ul>
                  <ul className="navbar-nav mb-2 mb-xl-0 nav_after_login flex flex-col gap-1.5 d-xl-none">
                    {siteDoc?.tradeAccess && (
                      <li className="nav-item">
                        <NavLink
                          to={isTrade ? "/trade" : "/"}
                          className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors"
                          onClick={() => { handleTrade(); handleCloseOffcanvas(); }}
                        >
                          <span className="font-medium text-[15px]">{t("TRADE")}</span>
                        </NavLink>
                      </li>
                    )}
                    {siteDoc?.stakeAccess && (
                      <li className="nav-item">
                        <Link
                          className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors"
                          to={isStake ? "/staking" : "/"}
                          onClick={() => { handleStake(); handleCloseOffcanvas(); }}
                        >
                          <span className="font-medium text-[15px]">{t("STAKING")}</span>
                        </Link>
                      </li>
                    )}
                    {siteDoc?.walletAccess && (
                      <li className="nav-item">
                        <Link to="/wallet" className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={handleCloseOffcanvas}>
                          <span className="font-medium text-[15px]">{t("WALLET")}</span>
                        </Link>
                      </li>
                    )}
                    {siteDoc?.transactionAccess && (
                      <li className="nav-item">
                        <Link to="/transaction-history" className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={handleCloseOffcanvas}>
                          <span className="font-medium text-[15px]">{t("TRANSACTION")}</span>
                        </Link>
                      </li>
                    )}
                    {siteDoc?.hedgeAccess && (
                      <li className="nav-item">
                        <Link
                          to={isHedge ? "/hedging" : "/"}
                          onClick={() => { handlehedge(); handleCloseOffcanvas(); }}
                          className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors"
                        >
                          <span className="font-medium text-[15px]">{t("HEDGE_FUND")}</span>
                        </Link>
                      </li>
                    )}
                    {siteDoc?.historyAccess && (
                      <li className="nav-item">
                        <Link to="/stakinghistory" className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={handleCloseOffcanvas}>
                          <span className="font-medium text-[15px]">{t("STAKING_HISTORY")}</span>
                        </Link>
                      </li>
                    )}
                    {siteDoc?.liveEventAccess && (
                      <li className="nav-item">
                        <NavLink
                          className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors"
                          to={isLiveEvents ? "/live-events" : "/"}
                          onClick={() => { handleLiveEvent(); handleCloseOffcanvas(); }}
                        >
                          <span className="font-medium text-[15px]">{t("LIVE_EVENTS")}</span>
                        </NavLink>
                      </li>
                    )}
                    
                    <li className="my-2 border-t border-[#395645]/10"></li>

                    <li className="nav-item">
                        <Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to="/account-settings" onClick={handleCloseOffcanvas}>
                        <span className="font-medium text-[15px]">{t("ACCOUNT_SETTINGS")}</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors"
                          onClick={() => { setProfileModal(true); handleCloseOffcanvas(); }}
                      >
                        <span className="font-medium text-[15px]">{t("EDIT_PROFILE")}</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to="/support-ticket" onClick={handleCloseOffcanvas}>
                        <span className="font-medium text-[15px]">{t("SUPPORT_TICKET")}</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link relative flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to="/notifications" onClick={handleCloseOffcanvas}>
                        <span className="font-medium text-[15px]">{t("NOTIFICATION")}</span>
                        {notifiyCount > 0 && (
                            <span className="bg-[#d22102] text-white text-[11px] font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center">{notifiyCount}</span>
                        )}
                      </Link>
                    </li>
                    <li className="nav-item mt-2">
                      <Link
                        className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors"
                          onClick={() => { logout(navigate, dispatch, t); handleCloseOffcanvas(); }}
                      >
                        <span className="font-medium text-[15px]">{t("LOGOUT")}</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-70"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                      </Link>
                    </li>
                  </ul>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
            {/* <ThemeToggle />

            <button
              type="button"
              class="lang_btn"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              <Image src={defaultLang.image} width={24} height={24} />
            </button> */}

            {/* <div className="form-group">
              <Dropdown className="image_dropdown_wrapper" drop="down">
                <Dropdown.Toggle id="dropdown-basic" className="image_dropdown">
                  <Image src={defaultLang?.image} width={40} height={38} />{" "}
                  {defaultLang?.label}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {langList.map((option, i) => (
                    <Dropdown.Item
                      key={i}
                      onClick={() => handleLanguage(option.value, option)}
                    >
                      <Image src={option.image} width={40} height={38} />{" "}
                      {option?.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
          </div>
        </nav>
      </div>

      {/* Change Language Modal */}
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5 model_head" id="exampleModalLabel">
                Change Language
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <ul className="flag_list">
                {langList.map((option, i) => (
                  <li
                    key={i}
                    onClick={() => handleLanguage(option.value, option)}
                    data-bs-dismiss="modal"
                    className={language === option.value ? "active" : ""}
                  >
                    <span>{option?.label}</span>
                    <Image src={option.image} width={24} height={24} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavbarInner;
